import React from 'react';
import "../styling/header.css"

const HireComponent = () => {

return (

<div className="container">
    <h3 className="center">Need a freelancer for your project?</h3>
    <br/>
    <a href="https://www.fiverr.com/fatinazahari_na/design-to-html-layouts?ref_ctx_id=f08f14bf-ece6-4e9d-8ddf-5ab7eabcb40a" rel="noopener noreferrer" target="_blank">
       <button className="btn btnLong">Check out my gig</button>
    </a>

    <br/><br/><br/><br/><br/>

    
</div>
        
)

}

export default HireComponent ;